import { useEffect } from 'react'
import recordPCEvent from 'core/utils/RecordEvent/recordPCEvent'

type TAppleLoginProps = {
  redirectURI: string
  clientId: string
  className?: string
  onLoginSuccess?: (data: any) => void
  onLoginError?: (error: any) => void
  children?: React.ReactNode
}
let appleScript: HTMLScriptElement | null = null
export default function AppleLogin(props: TAppleLoginProps) {
  useEffect(() => {
    if (appleScript || typeof window === 'undefined') {
      return
    }
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
    script.onload = () => {
      window.AppleID.auth.init({
        clientId: props.clientId,
        redirectURI: props.redirectURI,
        scope: 'name email',
        // state: '[STATE]',
        // nonce: '[NONCE]',
        usePopup: true,
      })
    }
    document.head.appendChild(script)
  }, [])
  return (
    <div
      className={props.className}
      onClick={() => {
        recordPCEvent.record('Home_HeroImage_Apple')
        window.AppleID.auth
          .signIn()
          .then((data) => {
            console.log('apple回调数据', data)
            props.onLoginSuccess?.(data)
          })
          .catch((error) => {
            console.log('apple回调错误', error)
            props.onLoginError?.(error)
          })
      }}
    >
      {props.children}
    </div>
  )
}
